import { Component } from '@angular/core';

@Component({
    selector: 'app-root',
    template: `<div class="center-star"><router-outlet></router-outlet></div>`
})
export class RootComponent {

}
